module.exports = __webpack_public_path__ + "static/media/silver-card.f56ad459.png";